import DiscartModal from "@/components/discard_modal/DiscartModal.vue";
import EventBus from "@/plugins/EventBus";
const Modal = {
    // every plugin for Vue.js needs install method
    // this method will run after Vue.use(<your-plugin-here>) is executed
    install(app) {

        // making our modal component global
        app.component('MyDialog', DiscartModal)

        // exposing global $modal object with method show()
        // method show() takes object params as argument
        // inside this object we can have modal title, text, styles... and also our callback confirm function
        
        app.config.globalProperties.$dialog = {
            show(params) {
                // if we use this.$modal.show(params) inside our original Vue instance
                // we will emit 'show' event with parameters 'params'
                EventBus.emit("show", params);
            }
        }
    }
}

export default Modal